import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import 'src/Pages/LibraryPages/librarypages.scss'

const IdeaFactory = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)
  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL_API}/IdeaFactoryProgram/Mentor/List`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: '*/*',
            },
            params: { pageNumber: page, pageSize },
          },
        )
        // Server-side pagination: base endpoint (no /lookup) returns { items, totalCount }.
        const d = response.data
        if (Array.isArray(d)) {
          setData(d)
          setTotal(d.length)
        } else {
          setData(d?.items ?? [])
          setTotal(d?.totalCount ?? 0)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [page, pageSize])

  const columns = [
    {
      title: 'Student Name',
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: 'Assigned By',
      dataIndex: 'assignedBy',
      key: 'assignedBy',
    },
    {
      title: 'Created On',
      dataIndex: 'createdOn',
      key: 'createdOn',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <button
          type="button"
          className="lpg__btn-primary"
          onClick={() => navigate(`/mentor-detail/${record.id}`)}
        >
          View Detail
        </button>
      ),
    },
  ]

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M9 18h6M10 22h4" />
              <path d="M15.1 14c.2-1 .7-1.8 1.4-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.2 1.5 1.4 2.5" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Idea Factory</h1>
            <p className="lpg__sub">Student ideas and submissions.</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          <Table
            columns={columns}
            dataSource={data}
            rowKey="id"
            pagination={{
              current: page,
              pageSize,
              total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
              onChange: (p, s) => {
                setPage(p)
                setPageSize(s)
              },
            }}
          />
        </div>
      )}
    </div>
  )
}

export default IdeaFactory
